export const getActionLabel = (action) => {
    if (!action) return null;
    const a = (typeof action === 'string' ? action : action.action || '').toLowerCase();
    if (a === 'approve') return 'Approve';
    if (a === 'deny') return 'Deny';
    if (a === 'approveonce') return 'Approve Once';
    if (a === 'submitlimit') return 'Limit Approval';
    if (a === 'send') return 'Send';
    if (a === 'donotsend') return 'Do Not Send';
    if (a === 'ask') return 'Discuss';
    return null;
};

export const getActionBadgeColor = (action) => {
    if (!action) return 'secondary';
    const a = (typeof action === 'string' ? action : action.action || '').toLowerCase();
    if (a === 'approve') return 'success';
    if (a === 'deny') return 'danger';
    if (a === 'approveonce') return 'secondary';
    if (a === 'ask') return 'warning';
    if (a === 'submitlimit') return 'secondary';
    if (a === 'reply') return 'secondary';
    if (a === 'send') return 'success';
    if (a === 'donotsend') return 'danger';
    return 'secondary';
};

export const getActionSentTimeMs = (action) => {
    if (!action) return null;
    const raw = action.sentTime ?? action.sent_time ?? action.loggedAt ?? action.createdOn ?? null;
    if (!raw) return null;

    if (raw instanceof Date) return raw.getTime();
    if (typeof raw === 'number') return raw;

    const parsed = new Date(raw).getTime();
    return Number.isNaN(parsed) ? null : parsed;
};

const normalizeComparableValue = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).trim().toLowerCase();
};

export const isActionFromCurrentUser = (action, user) => {
    const requestedBy = normalizeComparableValue(action?.requestedBy);
    if (!requestedBy) return false;

    const candidates = [
        user?.displayName,
        user?.email,
        user?.username,
        user?.name,
        user?.fullName,
    ]
        .map(normalizeComparableValue)
        .filter(Boolean);

    return candidates.includes(requestedBy);
};
